import { render, staticRenderFns } from "./videoConfigureForm.vue?vue&type=template&id=19d22ebd&scoped=true&"
import script from "./videoConfigureForm.vue?vue&type=script&lang=js&"
export * from "./videoConfigureForm.vue?vue&type=script&lang=js&"
import style0 from "./videoConfigureForm.vue?vue&type=style&index=0&id=19d22ebd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d22ebd",
  null
  
)

export default component.exports